module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', {
    staticStyle: {}
  }, [_c('div', {
    staticClass: "cd-transition-layer",
    class: {
      visible: _vm.isVisible
    }
  }), _c('div', {
    staticClass: "bgblackintro"
  }), _c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "animatedgradient"
  }), _c('div', {
    staticClass: "song"
  }, [_c('div', {
    staticClass: "menucontent"
  }, [_c('div', {
    staticClass: "sectiontitre"
  }, [_c('div', {
    staticClass: "logosection"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("@/assets/The_Songs_Button.png"),
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "introsection"
  }, [_vm._v("Learn the stories behind many of the most famous Christmas songs written by Jewish songwriters and listen to classic versions.")]), _c('hr', {
    staticClass: "lignemenu mt4"
  })])]), _c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carouselimages"
  }, _vm._l((_vm.container), function(chanson) {
    return _c('div', {
      staticClass: "songcard relative"
    }, [_c('div', {
      staticClass: "songtop"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'info-song-show',
          params: {
            id: chanson.id
          }
        }
      }
    }, [_c('img', {
      staticClass: "imagesong",
      attrs: {
        "src": _vm.imageFirstPos(chanson)
      }
    })])], 1)])
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cd2b608","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Song.vue
// module id = 1286
// module chunks = 1